import { __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkAvatarGroupItem } from './uitk-avatar.esm.js';
import styles from './uitk-avatar.css';

var getClassNameList = classNames.bind(styles);
var UitkAvatarGroupContext = React.createContext({});
var UitkAvatarGroup = function (props) {
    var size = props.size, items = props.items, children = props.children, overflow = props.overflow;
    var baseAvatarGroupClass = 'uitk-avatar-group';
    var avatarGroupClassNames = getClassNameList(baseAvatarGroupClass, "".concat(baseAvatarGroupClass, "-").concat(size));
    var renderOverflowIcon = function (count) { return React.createElement(UitkAvatarGroupItem, { text: "".concat(count, "+"), key: "uitk-overflow-icon" }); };
    var renderChildren = function () {
        var childrenArray = React.Children.toArray(children);
        var overflowChildren = childrenArray && overflow && childrenArray.length > overflow;
        var overflowCount = childrenArray && overflow && childrenArray.length - overflow;
        var newChildren = overflowChildren ? childrenArray.slice(0, overflow) : childrenArray;
        if (overflowChildren && overflowCount) {
            newChildren.push(renderOverflowIcon(overflowCount));
        }
        return newChildren;
    };
    var renderItems = function () {
        var overflowItems = items && overflow && (items === null || items === void 0 ? void 0 : items.length) > overflow;
        var overflowCount = items && overflow && items.length - overflow;
        var newChildrenFromProps = [];
        var newItems = overflowItems ? items === null || items === void 0 ? void 0 : items.slice(0, overflow) : items;
        newItems === null || newItems === void 0 ? void 0 : newItems.forEach(function (item, idx) {
            newChildrenFromProps.push(React.createElement(UitkAvatarGroupItem, __assign({ key: idx }, item)));
        });
        if (overflowItems && overflowCount) {
            newChildrenFromProps.push(renderOverflowIcon(overflowCount));
        }
        return newChildrenFromProps;
    };
    return (React.createElement("ul", { className: avatarGroupClassNames },
        React.createElement(UitkAvatarGroupContext.Provider, { value: { size: size, border: true } }, (!items && renderChildren()) || renderItems() || null)));
};
UitkAvatarGroup.defaultProps = {
    size: 'medium',
    overflow: 4
};
UitkAvatarGroup.displayName = 'UitkAvatarGroup';

export { UitkAvatarGroup, UitkAvatarGroupContext as default };
